var WelcomeTemplate = function WelcomeTemplate() {
  return "\n    \t\t<div class=\"welcome welcome-overlay\">\n   \t\t   \t<div class=\"welcome-title\"></div>\n      \t\t\t<div class=\"welcome-text\"></div>\n    \t\t</div>\n       ";
};
module.exports = WelcomeTemplate;